import React from 'react'

const SmartRouterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.334 19.975a2.027 2.027 0 0 0-2.027 2.027v2.667a2.027 2.027 0 0 0 2.027 2.026h17.334a2.027 2.027 0 0 0 2.026-2.026v-4.694H7.334Zm-2.338-.311a3.307 3.307 0 0 1 2.338-.969h20.64v5.974a3.307 3.307 0 0 1-3.306 3.306H7.334a3.307 3.307 0 0 1-3.307-3.306v-2.667c0-.877.349-1.718.969-2.338Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5.311c-1.83 0-3.585.727-4.88 2.02a.64.64 0 0 1-.905-.905 8.187 8.187 0 0 1 11.572 0 .64.64 0 0 1-.905.905A6.907 6.907 0 0 0 16 5.311Z"
        fill="url(#b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.013 7.944a3.945 3.945 0 0 0-2.79 1.156.64.64 0 1 1-.905-.905 5.224 5.224 0 0 1 7.39 0 .64.64 0 0 1-.905.905 3.945 3.945 0 0 0-2.79-1.156Z"
        fill="url(#c)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.02 10.608a.027.027 0 1 0 0 .053.027.027 0 0 0 0-.053Zm-1.307.027a1.307 1.307 0 1 1 2.613 0 1.307 1.307 0 0 1-2.613 0Z"
        fill="url(#d)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.007 10.023a.64.64 0 0 1 .64.64v8.667a.64.64 0 1 1-1.28 0v-8.667a.64.64 0 0 1 .64-.64Z"
        fill="url(#e)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 23.585a.307.307 0 1 0 0-.614.307.307 0 0 0 0 .614Zm-.973-.307a.973.973 0 1 1 1.947 0 .973.973 0 0 1-1.947 0Z"
        fill="url(#f)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.667 23.585a.307.307 0 1 0 0-.614.307.307 0 0 0 0 .614Zm-.974-.307a.973.973 0 1 1 1.947 0 .973.973 0 0 1-1.947 0Z"
        fill="url(#g)"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-34.99834 -13.62347 31.3321 -80.49133 33.985 30.407)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-17.4603 -5.11964 9.40466 -32.07413 24.973 8.432)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-11.3487 -3.85104 7.97303 -23.49588 21.845 9.975)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-134.873 11.614 2.577) scale(5.41352 18.4156)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-97.301 18.418 3.822) scale(14.7212 12.6247)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-2.8451 -2.85774 9.72143 -9.67842 9.463 24.761)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="g"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-2.8451 -2.85774 9.72143 -9.67842 12.129 24.761)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SmartRouterIcon